import React from 'react';
import Certifications from '../components/Certifications';

const CertificationsPage = () => {
  return (
    <div>
      <Certifications />
    </div>
  );
};

export default CertificationsPage;

